import { render } from "./candidates-grid.vue?vue&type=template&id=5599894a"
import script from "./candidates-grid.vue?vue&type=script&lang=js"
export * from "./candidates-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__